import { interiorBayCapacity } from "../utils/constants";
export const apiField = 'interior_bay_capacity';

interface InteriorBayCapacityField {
  type: string;
  apiField: string;
  missing?: any;
  label: string;
  tooltip: () => string;
  data?: InteriorBayCapacityFieldFieldOption[];
  min: number;
  max: number;
  step?: number;
}

interface InteriorBayCapacityFieldFieldOption {
  value: string;
  name: string;
}

function makeConfig(max: number = 4, step: number = 1, min: number = 0): InteriorBayCapacityField {  
  return {
    type: 'Number',
    label : "interiorBayCapacity",
    apiField,
    tooltip: undefined,
    min,
    max,
    missing:undefined,
    step,
  };
}

export const getInteriorBayCapacityField = (productId, minBlock, half_block_allowed?) => {
  let stepIncrement = half_block_allowed ? 0.5 : 1
  const upperLimit = interiorBayCapacity(productId, half_block_allowed)
  if(minBlock >= upperLimit){
    minBlock = upperLimit
    stepIncrement = 0
  }
  return makeConfig(upperLimit, stepIncrement, minBlock+stepIncrement);
};


